<template>
  <AbstractTask :event="event" :action="action" @open-edit-component="show">
    <template #editComponent>
      <UpdateTaskModal
        v-if="renderTaskModal"
        v-model:visible-action-modal="actionModalVisible"
        :task="{ ...action, fileIds: action.Folder?.files.map((file) => file.id) ?? [] }"
        :event="event"
        @open:ih-order-modal="$emit('open:ihOrderModal', $event)"
      />
    </template>
  </AbstractTask>
</template>

<script setup lang="ts">
import { type PropType, ref, provide, nextTick } from "vue";
import type { ActionListActionFields_Task_Fragment, EventListEventFieldsFragment } from "@/graphql";
import AbstractTask from "./AbstractTask.vue";
import UpdateTaskModal from "./modal/UpdateTaskModal.vue";
import {
  CommentUserIdInjectionKey,
  CommonTaskAdditionalComment,
} from "@/views/event-action/EventActionBoardInjectionKeys";

defineProps({
  action: {
    type: Object as PropType<ActionListActionFields_Task_Fragment>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment>,
    required: true,
  },
});
defineEmits(["open:ihOrderModal"]);
const renderTaskModal = ref(false);
const actionModalVisible = ref(false);
const show = async () => {
  renderTaskModal.value = true;
  await nextTick();
  actionModalVisible.value = true;
};
const commentUserId = ref<number>();
provide(CommentUserIdInjectionKey, commentUserId);
provide(CommonTaskAdditionalComment, ref<null>(null));
</script>
<style lang="scss" scoped></style>
